import { useState, useEffect } from 'react'

const Hero = () => {
  const [scrollY, setScrollY] = useState(0)

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY)
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  // Calculate zoom factor based on scroll position (subtle effect)
  const zoomFactor = 1 + (scrollY * 0.0003) // Very subtle zoom increase as user scrolls
  const parallaxY = scrollY * 0.4

  return (
    <section id="Hero" className="section hero relative h-screen min-h-[700px] flex items-center justify-center overflow-hidden bg-[#212331]">
      {/* Hero Background Image */}
      <div className="header-image-wrapper absolute inset-0 z-10">
        <div className="hero-image-overlay absolute inset-0 bg-gradient-to-r from-[#212331]/30 via-transparent to-transparent z-20"></div>
        <img 
          src="/testbackgroundoneai1.png" 
          alt="AI automation technology - test background" 
          className="header-image w-full h-full object-cover object-center"
          style={{
            transform: `translateY(${parallaxY}px) scale(${zoomFactor})`,
            transition: 'transform 0.1s ease-out',
          }}
        />
      </div>

      {/* Hero Content */}
      <div className="hero-content relative z-30 w-full text-white">
        <div className="hero-content-wrapper max-w-6xl mx-auto px-8 text-center">
          <div className="hero-top mb-16">
            <div className="grid grid-cols-1 gap-8 items-center justify-center">
              {/* Main Headline */}
              <div className="hero-headline-text max-w-4xl mx-auto">
                <h1 className="text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-bold leading-tight mb-8 animate-slide-up">
                  The Future is AI Agents
                </h1>
              </div>
              
              {/* Content */}
              <div className="home-hero-content-wrap max-w-2xl mx-auto animate-slide-up delay-200">
                <p className="text-lg md:text-xl lg:text-2xl mb-8 leading-relaxed text-white/90">
                  SaaS is dead. The future belongs to AI agents that think, act, and deliver results autonomously. 
                  Transform your business with intelligent automation that works 24/7.
                </p>
                
                {/* CTA Button */}
                <a 
                  href="/contact" 
                  className="group inline-flex items-center px-8 py-4 bg-blue-600 text-white text-lg font-semibold rounded-lg hover:bg-blue-700 transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl"
                >
                  <span className="mr-3">Get Started</span>
                  <svg 
                    className="w-5 h-5 transform group-hover:translate-x-1 transition-transform duration-300" 
                    fill="none" 
                    stroke="currentColor" 
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 12h14m-7-7l7 7-7 7" />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-30">
        <div className="flex flex-col items-center text-white/70">
          <span className="text-sm mb-2">Scroll Down</span>
          <div className="w-6 h-10 border-2 border-white/50 rounded-full flex justify-center">
            <div className="w-1 h-3 bg-white/50 rounded-full animate-bounce mt-2"></div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Hero
